import { render, staticRenderFns } from "./InquiryGroupTab.vue?vue&type=template&id=c41657e8&"
import script from "./InquiryGroupTab.vue?vue&type=script&lang=js&"
export * from "./InquiryGroupTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports